import React, { createContext, useContext, useState, useCallback } from 'react';
import en from '../data/translations/en.json';
import mr from '../data/translations/mr.json';

const translations = { en, mr };

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('mr'); // Default: Marathi

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => (prev === 'mr' ? 'en' : 'mr'));
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value !== undefined ? value : key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};

export default LanguageContext;
